import { Reveal, SectionHead } from "../components/Reveal";
import { PILLARS } from "../data/content";

export const Pillars = () => (
    <section id="arbitragem" data-testid="pillars-section" className="bg-graphite-deep py-24 sm:py-32">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
            <SectionHead
                dark
                eyebrow="Por que escolher a arbitragem"
                title="Cinco fundamentos para decidir com segurança"
                lead="A arbitragem permite que as partes estabeleçam previamente as regras para a resolução de uma controvérsia, com procedimento estruturado e adequado à natureza do conflito."
            />

            <div className="mt-16">
                {PILLARS.map((p, i) => (
                    <Reveal key={p.roman} delay={0.06 * i}>
                        <div className="group grid items-baseline gap-4 border-t border-graphite-line py-9 transition-colors last:border-b hover:bg-graphite-dark/60 md:grid-cols-[90px_1fr_1.5fr] md:gap-8 md:px-4">
                            <span className="font-serif text-3xl text-gold/90 md:text-4xl">
                                {p.roman}
                            </span>
                            <h3 className="font-serif text-2xl text-cream transition-colors duration-300 group-hover:text-gold-light">
                                {p.title}
                            </h3>
                            <p className="max-w-2xl text-sm leading-relaxed text-graphite-mute">
                                {p.text}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
